// Cart observer
document.addEventListener('DOMContentLoaded', function () {
    const targetNode = document.getElementById('liquid__cart__quantity__number');

    if (targetNode) {
        // Function to update classes based on the cart quantity
        function updateCartClasses(quantity) {
            const cartIcon = document.querySelector('.header__dj-cart-icon');
            const cartTrigger = document.querySelector('.dj-cart-trigger');
            const utilityNav = document.querySelector('.header__utility-nav');

            if (quantity >= 1) {
                cartIcon.classList.add('has-items');
                cartTrigger.classList.add('visible');
                utilityNav.classList.add('header__utility-dj');
            } else {
                cartIcon.classList.remove('has-items');
                cartTrigger.classList.remove('visible');
                utilityNav.classList.remove('header__utility-dj');
            }
        }

        // Create an observer instance linked to a callback function
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'characterData' || mutation.type === 'childList') {
                    const newValue = targetNode.textContent;
                    const quantity = newValue && !isNaN(newValue) ? parseInt(newValue, 10) : 0;
                    updateCartClasses(quantity);
                }
            });
        });

        // Start observing the target node for configured mutations
        observer.observe(targetNode, {
            characterData: true, // Observe changes in text content
            subtree: true, // Observe changes in descendants (important for text nodes within span)
            childList: true, // Observe direct children changes
        });

        // Optional: Disconnect observer when no longer needed to avoid memory leaks
        // observer.disconnect();
    } else {
        console.error('The target element does not exist.');
    }
});
